class PushCartUpsells extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['element-to-update']
  }

  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  onCartChanged (event) {
    if (
      event?.detail?.state?.items?.[0]?.product_id &&
      event?.detail?.state?.items_removed?.length
    ) {
      /* Item removed from cart */
      this.setUpdatedProductId(event.detail.state.items[0].product_id)
      return
    }

    if (event?.detail?.state?.product_id) {
      /* Item added to cart */
      this.setUpdatedProductId(event?.detail?.state?.product_id)
      return
    }

    if (!event?.detail?.state?.items?.length) {
      /* Cart is empty */
      this.setUpdatedProductId('')
    }
  }

  setUpdatedProductId (productId) {
    this.els['element-to-update'].element.setAttribute(
      'data-product-id',
      productId,
    )
  }
}

if (!customElements.get('push-cart-upsells')) {
  customElements.define('push-cart-upsells', PushCartUpsells)
}
